/**
 * @author: liaosir
 * @description: 根据入参返回对应映射
 */
/**
 * @param value
 * @param type
 * @returns string
 * @example tranformDict('CNDGMA', 'allWarehouseDict);
 */

import React from 'react';

interface Options {
  valueName: string;
  labelName: string;
}

const customDict = ['fbaChannelDict'];

const tranformDict = (
  value: string,
  type: 'fbaChannelDict' | string,
  condition: React.ReactNode = true, // 自定义条件
  options: Options = { valueName: 'value', labelName: 'label' },
) => {
  const newOptions = { ...options };
  let str: string = window.sessionStorage.getItem(type) || '';

  // 字典list数据
  let dictList: [] = [];

  if (customDict?.includes(type)) {
    // 自定义字典
    if (!str) return;
    dictList = JSON.parse(str) || [];
  } else {
    // 所有字典
    str = window.sessionStorage.getItem('allDict') || '';
    if (!str) return;

    const allDict: [] = JSON.parse(str)[type.toUpperCase()] || [];
    dictList = allDict;
    newOptions.labelName = 'name';
    newOptions.valueName = 'code';
  }
  const el = dictList.find((e: string) => condition && e[newOptions.valueName]?.toUpperCase() === value?.toUpperCase());
  return el ? el[newOptions.labelName] : value;
};

export { tranformDict };
